import React from 'react';
import LwtTable from 'components/@common/Table/LwtTable';
import { useTranslation } from 'react-i18next';
import getAllStudentModuleColumns from './AllStudentModuleColumns';
import { makeStyles } from '@material-ui/core';
import getSingleStudentModuleColumns from './SingleStudentModuleColumns';
import { upperCase } from 'lodash';
import { AssessmentSubmodulesNames } from 'components/ReportsModule/types';

type Props = {
  selectedModule?: any;
  data: any[];
};

const StudentTable: React.FC<Props> = ({ selectedModule, data }) => {
  const classes = useStyles();
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);
  const TUpper = (val: any) => upperCase(t(val, { ns: 'ReportsHelpTableColumns' }));
  const showAll = selectedModule === AssessmentSubmodulesNames.ALL_MODULES;
  const columns = showAll
    ? getAllStudentModuleColumns(t, TUpper)
    : getSingleStudentModuleColumns(t, TUpper);

  return <LwtTable columns={columns} data={data} classes={{ row: () => classes.tableRow }} />;
};

const useStyles = makeStyles(() => ({
  tableRow: {
    background: '#FCFCFC'
  }
}));
export default StudentTable;
